module.exports = __webpack_public_path__ + "static/media/zitsafund.9e610c8c.png";